import { ProfileResponseSchema } from './profile.schema';
/**
 * Profile Endpoint Contract
 * Fetches the current authenticated user's profile
 */ export const profileContract = {
    method: 'GET',
    path: '/api/v2/profile',
    description: 'Fetches the authenticated user profile with full details',
    responseSchema: ProfileResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - invalid or missing token'
        }
    }
};

//# sourceMappingURL=profile.contract.js.map